module.exports = __webpack_public_path__ + "static/media/nynfc7.f45a51a1.jpg";